import React, { ReactElement, useState, useEffect } from "react";
import { Button } from "@screencloud/screencloud-ui-components";
import CopyToClipboard from "react-copy-to-clipboard";
import { Stream } from "../../types";
import "./StreamInfo.scss";

interface StreamInfoProps {
  stream: Stream | null;
  backgroundColor?: string;
}

const TITLES = {
  URL: "Streaming Channel URL",
  KEY: "Streaming Channel Key",
  PAGE: "Live Streaming Page URL",
};

const StreamInfo = (props: StreamInfoProps): ReactElement<StreamInfoProps> => {
  const { stream } = props;
  const backgroundColorClass = props.backgroundColor
    ? props.backgroundColor
    : "yellow";
  const [streamingUrlCopied, setStreamingUrlCopied] = useState(false);
  const [streamKeyCopied, setStreamKeyCopied] = useState(false);
  const [pageUrlCopied, setPageUrlCopied] = useState(false);

  useEffect(() => {
    if (streamingUrlCopied) {
      const timeout = setTimeout(() => setStreamingUrlCopied(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [streamingUrlCopied]);

  useEffect(() => {
    if (streamKeyCopied) {
      const timeout = setTimeout(() => setStreamKeyCopied(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [streamKeyCopied]);

  useEffect(() => {
    if (pageUrlCopied) {
      const timeout = setTimeout(() => setPageUrlCopied(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [pageUrlCopied]);

  return stream ? (
    <div className={`stream-info grid ${backgroundColorClass}`}>
      <div className="row">
        <div className="label title">{TITLES.URL}</div>
        <div className="value">{stream.ingestEndpoint} </div>
        <div className="copyButton">
          <CopyToClipboard
            text={stream.ingestEndpoint || ""}
            onCopy={() => setStreamingUrlCopied(true)}
          >
            <Button primary>{streamingUrlCopied ? "Copied" : "Copy"}</Button>
          </CopyToClipboard>
        </div>
      </div>
      <div className="row">
        <div className="label">{TITLES.KEY}</div>
        <div className="value">{stream.streamKey} </div>
        <div className="copyButton">
          <CopyToClipboard
            text={stream.streamKey || ""}
            onCopy={() => setStreamKeyCopied(true)}
          >
            <Button primary>{streamKeyCopied ? "Copied" : "Copy"}</Button>
          </CopyToClipboard>
        </div>
      </div>
      <div className="row">
        <div className="label">{TITLES.PAGE}</div>
        <div className="value">
          <span>
            {`${process.env.REACT_APP_BASE_URL}/view/${stream.screenCloudOrgId}/${stream.spaceId}/${stream.channelId}`}{" "}
          </span>
        </div>
        <div className="copyButton">
          <CopyToClipboard
            text={`${process.env.REACT_APP_BASE_URL}/view/${stream.screenCloudOrgId}/${stream.spaceId}/${stream.channelId}`}
            onCopy={() => setPageUrlCopied(true)}
          >
            <Button primary>{pageUrlCopied ? "Copied" : "Copy"}</Button>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};

export default StreamInfo;
